<template>

    <section id="new_ref_fifth_step" class="flex" v-if="associatedRef">


        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentEval.candidate_first_name }} {{ currentEval.candidate_last_name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.evaluations.formStep4.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

            <div class="hero flex subsection_container">

            <div class="hero-body flex_content">
                <div class="container  micro-container has-text-centered">

                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">
                        {{ $t('modules.evaluations.formStep4.title') }}
                    </h2>

                    <div class="form_material_container">

                        <FilesUploader @fileUploaded="handleUploadedFile" />
                        <br>
                        <btn-circle-icon
                            class="large is-cursor"
                            icon="icon-arrow-right"
                            @click.native="nextStep" />
                    </div>
                </div>
            </div>
        </div>

    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import FilesUploader from '@/components/shared/filesUploader/filesUploader'

export default {
    name: 'formEvalStep4',
    components: {
        titlePage,
        FilesUploader
    },
    data(){
        return {

        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        associatedRef(){
            return this.$store.state.EvalStore.associatedRef
        }
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        handleUploadedFile(fileList){
            this.$store.commit('EvalStore/updateEvalData', {id: this.currentEval.id, docs_ids: fileList})
        },
        nextStep(){
            this.$store.commit('EvalStore/changeCurrentStep', { index: 4 })
        },
    }
}
</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;

    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}
</style>